import React from 'react'
import { connect } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { Tabs, Tab, Paper, Box } from '@material-ui/core'
import ProductionRatesTable from './ProductionRatesTable'
import LaborRatesTable from './LaborRatesTable'
import EquipmentRatesTable from './EquipmentRatesTable'
import MaterialCatalogTable from './MaterialCatalogTable'
import ServiceTemplatesTable from './ServiceTemplatesTable'
import ServiceAttributesTab from './ServiceAttributesTab'
import BidEstimationHeader from '../shared/BidEstimationHeader'

const TabPanel = ({ children, value, index }) => {
  if (value !== index) return null
  return (
    <Box p={2}>
      {children}
    </Box>
  )
}

const RateTablesView = (props) => {
  const [tab, setTab] = React.useState(0)
  const location = useLocation()

  // If the user came from a project dashboard, we want "Back" to return them
  // there. ProjectDashboard navigates here via history.push with a state
  // payload; fall back to the project list if no state is present.
  const fromProjectId = location.state && location.state.fromProjectId
  const fromProjectName = location.state && location.state.fromProjectName
  const backTo = fromProjectId ? `/bid-estimation/${fromProjectId}` : '/bid-estimation'
  const backLabel = fromProjectId ? 'Project' : 'Projects'
  const breadcrumbs = fromProjectId
    ? [
      { label: 'Bid Estimation', to: '/bid-estimation' },
      { label: fromProjectName || 'Project', to: `/bid-estimation/${fromProjectId}` },
      { label: 'Rate Tables' }
    ]
    : [
      { label: 'Bid Estimation', to: '/bid-estimation' },
      { label: 'Rate Tables' }
    ]

  return (
    <div style={{ padding: 20 }}>
      <BidEstimationHeader
        backTo={backTo}
        backLabel={backLabel}
        breadcrumbs={breadcrumbs}
        title="Rate Tables"
      />
      <Paper>
        <Tabs
          value={tab}
          onChange={(e, newVal) => setTab(newVal)}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Production Rates" />
          <Tab label="Labor Rates" />
          <Tab label="Equipment Rates" />
          <Tab label="Material Catalog" />
          <Tab label="Service Templates" />
          <Tab label="Service Attributes" />
        </Tabs>
        <TabPanel value={tab} index={0}>
          <ProductionRatesTable url={props.url} />
        </TabPanel>
        <TabPanel value={tab} index={1}>
          <LaborRatesTable url={props.url} />
        </TabPanel>
        <TabPanel value={tab} index={2}>
          <EquipmentRatesTable url={props.url} />
        </TabPanel>
        <TabPanel value={tab} index={3}>
          <MaterialCatalogTable url={props.url} />
        </TabPanel>
        <TabPanel value={tab} index={4}>
          <ServiceTemplatesTable url={props.url} />
        </TabPanel>
        <TabPanel value={tab} index={5}>
          <ServiceAttributesTab url={props.url} />
        </TabPanel>
      </Paper>
    </div>
  )
}

const mapStateToProps = (state) => ({
  url: state.url,
  user: state.user,
  authenticated: state.authenticated
})

export default connect(mapStateToProps)(RateTablesView)
